import React, { useState, useEffect } from 'react'
import Slider from 'react-slick'
import Image from '../atoms/Image'
import Headline from '../atoms/Headline'
import Link from '../atoms/Link'
import SbEditable from 'storyblok-react'
import Modal from 'react-modal'
import { Helmet } from 'react-helmet'
import Video from '../atoms/Video'

const HeroRotationBlock = ({ block }) => {
  const [modalIsOpen, setIsOpen] = useState(false)
  const [currentItem, setCurrentItem] = useState(null)

  const openModal = () => {
    //e.preventDefault()
    setIsOpen(true)
  }
  const closeModal = () => {
    //e.preventDefault()
    setIsOpen(false)
  }

  const settings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    mobileFirst: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
  }

  useEffect(() => {
    return () => {
      setCurrentItem(null)
      setIsOpen(false)
    }
  }, [])

  return (
    <SbEditable content={block}>
      <section className="hero-rotation-block">
        <Slider {...settings}>
          {block.hero_rotation_block_content?.length > 0 &&
            block.hero_rotation_block_content.map((item, index) => (
              <article
                className={`hero-rotation-block-item ${
                  item.hero_mirrored && 'hero-mirrored'
                }`}
                key={index}
              >
                <div className="hero-rotation-block-item-image-container">
                  <div className="hero-rotation-block-item-image">
                    <div className="hero-rotation-block-item-image-overlay"></div>
                    <div data-rellax={true} data-rellax-speed={-5}>
                      <Image
                        image={item.image}
                        alt={item.alt}
                        //imageWidth="1397"
                        //imageHeight="786"
                        forceLoad={index === 0 ? true : false}
                      />
                    </div>
                    {item.video_url?.length > 0 && (
                      <div
                        className="hero-rotation-block-play-button"
                        onClick={() => {
                          setCurrentItem(item)
                          openModal()
                        }}
                      >
                        <i className="fas fa-play"></i>
                      </div>
                    )}
                  </div>
                </div>
                <div className="hero-rotation-block-item-text-overlay">
                  <div className="hero-rotation-block-item-text-container">
                    <div className="hero-rotation-block-item-text">
                      <div className="hero-rotation-block-item-text-inner">
                        <Headline
                          headline={item.headline}
                          headline_level="h2"
                        />
                        {item.text && item.text.length > 0 && (
                          <p>{item.text}</p>
                        )}
                        {item.video_url && item.video_url.length > 0 ? (
                          <></>
                        ) : (
                          item.link && (
                            <Link
                              className="btn btn-link"
                              link={item.link}
                              target={item.tab_link ? '_blank' : '_self'}
                            >
                              {item.link_text}
                            </Link>
                          )
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </article>
            ))}
        </Slider>
      </section>
      {currentItem !== null && (
        <Modal
          isOpen={modalIsOpen && currentItem !== null}
          onRequestClose={() => closeModal()}
          style={{
            overlay: {
              backgroundColor: 'rgba(0,0,0,.5)',
              zIndex: '1060',
              cursor: 'pointer',
            },
            content: {
              background: 'transparent',
              border: 'none',
              inset: '0',
              padding: '1.5rem',
              pointerEvents: 'none',
            },
          }}
          shouldCloseOnOverlayClick={true}
        >
          <Helmet bodyAttributes={{ class: 'overflow-hidden' }} />
          <div className="modal-inner">
            <div className="modal-header">
              <h4 className="modal-title" id="spa-modal-label">
                {currentItem?.headline}
              </h4>
              <input
                className="btn btn-close"
                type="button"
                value=""
                onClick={(e) => closeModal(e)}
              />
            </div>
            <div className="modal-body">
              <div className="figmedia">
                <Video
                  video={currentItem?.video_url + '?badge=0&autoplay=1&html5=1'}
                />
              </div>
            </div>
          </div>
        </Modal>
      )}
    </SbEditable>
  )
}

export default HeroRotationBlock
